const utils = require('./utils');

export const deposit = async (contractAddress, amount, selectedAccount, web3, setConfirm) => {
  const maticPOSClient = utils.getMaticPOSClient(selectedAccount, web3);
  
  try {
    let chestConfig = contractAddress;

    let gasPrice = await web3.eth.getGasPrice();        
    let gasPriceBN = web3.utils.toBN(gasPrice);
    let finalGasPrice = gasPriceBN.add(web3.utils.toBN(parseInt(0.1 * gasPriceBN))).toString();

    const tx = await maticPOSClient.depositERC20ForUser(
      chestConfig,
      selectedAccount,
      amount,
      {
        from: selectedAccount,
        gasPrice: finalGasPrice,
      },
    );
    setConfirm('deposit');
    // setConfirm('deposit-success');
    // console.log(tx.transactionHash); // eslint-disable-line
    return { "txhash": tx.transactionHash, "chestConfig": chestConfig };
  } catch (e) {
    setConfirm('');
    console.error(e); // eslint-disable-line
    throw new Error(e);
  }
};